module.exports = new __parcel__URL__("manage-fields.563085bd.gif").toString();